<template>
    <div>
        <div class="dataTable">
            <b-table id="product-table"
                :fields="productFields"
                :items="prodcutItems"
                small
                bordered
                hover
                show-empty
                empty-text="没有找到匹配的记录"
                :busy="isTableBusy"
                caption-top>
                <template slot="table-caption">搜索到 {{feSearch.limit.conditions.total}} 条数据.</template>
                <template v-slot:cell(productImg)="row">
                    <img :src="row.item.productFinishImageFile.url"
                        width="30"
                        height="30">
                </template>
                <template v-slot:cell(orderQuantity)="row">
                    <b-form-input size="sm"
                        v-model="row.item.orderQuantity">
                    </b-form-input>
                </template>
                <template v-slot:cell(detailButton)="row">
                    <a href="#"
                        v-on:click="onProductDetail(row)">详情</a>
                </template>
                <div slot="table-busy"
                    class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>加载中...</strong>
                </div>

            </b-table>
        </div>
        <div class="pageControl">
            <b-pagination v-model="feSearch.limit.conditions.pageStart"
                style="margin-top:20px;"
                :total-rows="feSearch.limit.conditions.total"
                :per-page="feSearch.limit.conditions.pageLength"
                align="center"
                size="sm"
                ellipsis-text="..."
                first-text="首页"
                prev-text="上一页"
                next-text="下一页"
                last-text="尾页"
                limit="10"
                @change="onPageChange"></b-pagination>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import "@/style/global.css";
export default {
    name: "ProductSearch",
    data() {
        return {
            showSpin: false,
            isTableBusy: false,
            loadingInterval: 300,
            productFields: [
                { key: 'productImg', label: '缩图' },
                { key: 'productCode', label: '编码' },
                { key: 'productName', label: '品名' },
                { key: 'productSpec', label: '规格' },
                { key: 'brandName', label: '品牌' },
                { key: 'unitName', label: '单位' },
                { key: 'packagePrice', label: '纸箱费' },
                { key: 'packageQuantity', label: '装箱量' },
                { key: 'productCurSalePrice', label: '单价' },
                { key: 'productCurSaleWarehouseAmount', label: '现苗量' },
                { key: 'detailButton', label: '操作' }
            ],
            prodcutItems: [],
            feSearch: search.getSearchParams()
        };
    },
    mounted() {
        this.feSearch.filters.enable = true;
        this.feSearch.filters.join = 'or';
        this.feSearch.filters.conditions.push({
            name: 'productName',
            type: 'like',
            value: this.$route.query.searchValue
        });
        this.feSearch.filters.conditions.push({
            name: 'productCode',
            type: 'like',
            value: this.$route.query.searchValue
        });
        this.getProductList();
    },
    methods: {
        getProductList() {
            this.isTableBusy = true;
            setTimeout(() => {
                api.getProductList(this.feSearch).then(res => {
                    this.isTableBusy = false;
                    if (res.code === 0) {
                        this.prodcutItems = res.data.records;
                        this.prodcutItems.forEach(p => {
                            if (p.productFinishImageFile) {
                                p.productFinishImageFile = JSON.parse(p.productFinishImageFile);
                                p.productFinishImageFile.url = api.fileServer + p.productFinishImageFile.url;
                            }
                        });
                        search.globalSetFilterRecordCount(this.feSearch, res.data.filterRecordCount);
                    }
                });
            }, this.loadingInterval);
        },
        onPageChange(pageNum) {
            search.globalPageOnChange(this.feSearch, pageNum);
            this.getProductList();
        },
        onProductDetail(row) {
            let routeUrl = this.$router.resolve({
                path: '/product/product-detail',
                query: { productUuid: row.item.productUuid }
            });
            window.open(routeUrl.href, '_blank');
        }
    },
    components: {

    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/product/product-search.vue